import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

import { DynamicSmartOffer } from "../DynamicSmartOffer";

interface SessionState {
    latestData: DynamicSmartOffer;
}

interface DynamicSmartOfferStore {
    sessions: Record<string, SessionState>;
    getSession: (sessionId: string) => SessionState;
    receiveData: (sessionId: string, data: DynamicSmartOffer) => void;
    reset: (sessionId: string) => void;
}

const defaultSessionState: SessionState = {
    latestData: new DynamicSmartOffer("", []),
};

export const useDynamicSmartOfferStore = create<DynamicSmartOfferStore>()(
    persist(
        immer(
            devtools(
                (set, get) => ({
                    sessions: {},
                    getSession: (sessionId: string) => get().sessions[sessionId] ?? defaultSessionState,
                    receiveData: (sessionId: string, data: DynamicSmartOffer) => {
                        set(
                            (state: DynamicSmartOfferStore) => {
                                state.sessions[sessionId] = { latestData: data };
                            },
                            false,
                            "receiveData",
                        );
                    },
                    reset: (sessionId: string) => {
                        set(
                            (state: DynamicSmartOfferStore) => {
                                delete state.sessions[sessionId];
                            },
                            false,
                            "reset",
                        );
                    },
                }),
                {
                    enabled: !import.meta.env.PROD,
                    store: "dynamic-smart-offer-store",
                    name: "workspace/sales-tools",
                },
            ),
        ),
        { name: "dynamic-smart-offer-store", skipHydration: true },
    ),
);
